import { render, staticRenderFns } from "./SwiperImage1.vue?vue&type=template&id=2fdaaa04&scoped=true&"
import script from "./SwiperImage1.vue?vue&type=script&lang=js&"
export * from "./SwiperImage1.vue?vue&type=script&lang=js&"
import style0 from "./SwiperImage1.vue?vue&type=style&index=0&id=2fdaaa04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdaaa04",
  null
  
)

export default component.exports